import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  loading = false,
  onClick,
  type = 'button',
  className = '',
  ...props
}) => {
  const baseClasses = 'font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-200';

  const variantClasses = {
    primary: 'bg-teal-500 hover:bg-teal-600 text-white border-2 border-slate-900 shadow-retro hover:shadow-retro-hover hover:-translate-y-0.5 focus:ring-teal-500',
    secondary: 'bg-purple-500 hover:bg-purple-600 text-white border-2 border-slate-900 shadow-retro hover:shadow-retro-hover hover:-translate-y-0.5 focus:ring-purple-500',
    success: 'bg-teal-500 hover:bg-teal-600 text-white border-2 border-slate-900 shadow-retro hover:shadow-retro-hover hover:-translate-y-0.5 focus:ring-teal-500',
    danger: 'bg-coral-500 hover:bg-coral-600 text-white border-2 border-slate-900 shadow-retro hover:shadow-retro-hover hover:-translate-y-0.5 focus:ring-coral-500',
    warning: 'bg-sunshine-500 hover:bg-sunshine-600 text-white border-2 border-slate-900 shadow-retro hover:shadow-retro-hover hover:-translate-y-0.5 focus:ring-sunshine-500',
    outline: 'border-2 border-teal-500 text-teal-600 bg-white hover:bg-teal-50 shadow-retro hover:shadow-retro-hover hover:-translate-y-0.5 focus:ring-teal-500',
    ghost: 'text-teal-600 hover:bg-teal-50 focus:ring-teal-500',
    gradient: 'bg-gradient-to-r from-teal-500 via-purple-500 to-magenta-500 hover:from-teal-600 hover:via-purple-600 hover:to-magenta-600 text-white border-2 border-slate-900 shadow-retro hover:shadow-retro-hover hover:-translate-y-0.5 focus:ring-purple-500'
  };

  const sizeClasses = {
    small: 'px-3 py-1.5 text-sm',
    medium: 'px-4 py-2 text-base',
    large: 'px-6 py-3 text-lg'
  };

  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : '';

  const buttonClasses = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${className}`.trim();

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={onClick}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <div className="flex items-center justify-center">
          <svg className="animate-spin -ml-1 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Loading...
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;